import { requestApi } from '@app/api';
import { withPayment } from '@app/api/paths';

export type GetPaymentOptionResponse = {
  id: string;
  workspaceId: string;
  retrying: boolean;
  updatedAt: string;
  createdAt: string;
};

function getPaymentOptions(workspaceId: string): Promise<GetPaymentOptionResponse> {
  return requestApi<GetPaymentOptionResponse>({
    url: withPayment(`/workspaces/${workspaceId}/payment-options`),
    method: 'GET',
    credentials: true,
  }).then((response) => response.data);
}

export default getPaymentOptions;
